import React, { Component } from 'react';
export default class Tabs extends Component {
    constructor(props){
        super(props);
        //console.log(props)
        this.state = {
            current: 0,
            activeclass:props.activeclass,
            secondclass:props.secondclass,
            navclass:props.navclass,
            contentclass:props.contentclass
        };

    }

    tabnav = (index) => {
        return index === this.state.current ? this.props.activeclass : this.props.secondclass;
    }

    tabitem = (index) => {
        return index === this.state.current ? 'd-block' : 'd-none';
    }

    render(){
        return (
            <div className="row">
                <ul className={this.state.navclass}>
                    {
                        React.Children.map(this.props.children,(element,index) => {
                              return (
                                  <li onClick={ ()=>this.setState({current:index}) } className={ this.tabnav(index) }>{ element.props.name }</li>
                              )
                        })
                    }
                </ul>
                <div className={this.state.contentclass}>
                    {
                        React.Children.map(this.props.children, (element,index) => {
                            return (
                                <div className={ this.tabitem(index) }>{ element }</div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tabs.js